<template>
  <d2-container>

    <template slot="header">
      <div class="overview">
      <div class="header" flex="main:justify">
        <div flex="cross:center">
          <div class="header__line"></div>
          <div class="header__title"> 数据统计  <el-popover
                  placement="top-start"
                  title="温馨提示"
                  width="400"
                  trigger="hover"
          >
            <li>显示自己和下级的交易总额和补贴手续费总额</li>
            <el-button
                    slot="reference"
                    size="mini"
                    icon="el-icon-question"
            ></el-button>
          </el-popover>        仅统计近一年的数据</div>

        </div>
      </div>
      <div class="overview__row" flex="box:mean">
        <div class="overview__col" flex="dir:top cross:center">
          <div class="overview__title">交易总额</div>
          <div>{{yx_order_amount}}/{{wz_num}}</div>
        </div>
        <div class="overview__col" flex="dir:top cross:center" >
          <div class="overview__title">微信交易金额/补贴手续费总额</div>
          <div>{{wx_num_amount}}/{{wx_num}}</div>
        </div>
        <div class="overview__col" flex="dir:top cross:center" >
          <div class="overview__title">支付宝交易金额/补贴手续费总额</div>
          <div>{{zfb_num_amount}}/{{zfb_num}}</div>
        </div>
        <div class="overview__col" flex="dir:top cross:center">
          <div class="overview__title">随行付交易金额/补贴手续费总额</div>
          <div>{{sxf_num_amount}}/{{yhk_num}}</div>
        </div>
        <div class="overview__col" flex="dir:top cross:center" >
          <div class="overview__title">乐刷交易金额/补贴手续费总额</div>
          <div>{{fy_num_amount}}/{{fyk_num}}</div>
        </div>
      </div>
      </div>
      <el-form
              :model="searchForm"
              ref="searchForm"
              label-width="10px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)"
      >
        <el-form-item

        >

          <div flex="cross:center">
            <div class="header__line"></div>
            <div class="header__title">  补贴手续费清单 <el-popover
                    placement="top-start"
                    title="温馨提示"
                    width="400"
                    trigger="hover"
            >
              <li>显示结算/未结算的补贴手续费</li>
              <el-button
                      slot="reference"
                      size="mini"
                      icon="el-icon-question"
              ></el-button>
            </el-popover>已结算：{{js_amount}}元,未结算：{{wjs_amount}}</div>
          </div>
        </el-form-item
>
      </el-form>
      <el-divider></el-divider>
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item>
          <el-date-picker
                  v-model="dateRange"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"    width="150">

          </el-date-picker>

        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.js_state"
                  placeholder="结算状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.velue"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
                label="商家名称"
                prop="noticeTitle"
        >
          <el-input
                  v-model="searchForm.agent_name"
                  placeholder="商家名称"
                  style="width: 100px;"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
          <el-button
                  type="primary"
                  @click="handleExportFormSubmit"
          >
            <d2-icon name="share" /> 导出
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
            v-if="multipleSelection.length>0"
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="batchDel"
    >
      批量补贴
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="商家名称"
      >
        <template slot-scope="scope">
          {{scope.row.agent_name}}
        </template>
      </el-table-column>

      <el-table-column
        label="法人"
        width="100"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.wx_num}}
        </template>
      </el-table-column>
      <el-table-column
              label="商家地址"
              width="130"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.yhk_num}}
        </template>
      </el-table-column>
      <el-table-column
              label="交易金额"
              width="150"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.wx_num_bf}}元
        </template>
      </el-table-column>
      <el-table-column
            label="补贴手续费总额"
            width="160"
            :show-overflow-tooltip="true"
    >
      <template slot-scope="scope">
        {{scope.row.zfb_num_bf}}元
      </template>
    </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        align="center"
      >
          <template slot-scope="scope">
            <el-button type="primary" plain  size="mini"  @click="openEditForm(scope.row)">明细</el-button>
            <el-button type="primary" plain size="mini"  v-if="scope.row.js_state=='0'"  @click="updateRelation(scope.row)">补贴手续费</el-button>

          </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
            :agent="agent"
            v-model="editFormVisible"
            :pickerValue2="pickerValue2"
            :pickerValue3="pickerValue3"
            @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as noticeService from '@/api/sys/notice'
import * as agentService from '@/api/sys/agent'
import util from '@/libs/util.js'
import editForm from './editForm'
export default {
  name: 'CommissionPage',
  components: { editForm },
  data () {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
    end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
    return {
      searchForm: {
        js_state: '',
        agent_name: ''
      },
      js_amount: '',
      wjs_amount: '',
      yx_order_amount: '',
      wx_num_amount: '',
      zfb_num_amount: '',
      sxf_num_amount: '',
      fy_num_amount: '',
      wx_num: '',
      zfb_num: '',
      yhk_num: '',
      fyk_num: '',
      wz_num: '',
      dateRange: [start, end],
      pickerValue2: '',
      pickerValue3: '',
      pickerOptions: {},
      loading: false,
      tableData: [],
      tableData2: [],
      multipleSelection: [],
      typeOptions: [
        {
          value: '结算',
          label: '结算'
        },
        {
          value: '未结算',
          label: '未结算'
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: '',
        order: ''
      },
      agent: {},
      editFormVisible: false
    }
  },
  mounted () {
    this.getTableData()
    this.getTableDataYj()
    this.getTableDataJs()
  },
  methods: {
    getTableDataYj () {
      var formData4 = new FormData() // 声明一个FormData对象
      // formData4.append("start_time",this.dateConversion(this.dateRange[0]));
      // formData4.append("end_time",this.dateConversion(this.dateRange[1]));

      agentService.getStatisticsOrderBt(formData4).then(data => {
        if (data != null && data != '') {
          this.one_agent_num = data.one_agent_num
          this.yx_order_amount = data.yx_order_amount
          this.wx_num_amount = data.wx_num_amount
          this.zfb_num_amount = data.zfb_num_amount
          this.sxf_num_amount = data.sxf_num_amount
          this.fy_num_amount = data.fy_num_amount
          this.wx_num = data.wx_num
          this.zfb_num = data.zfb_num
          this.yhk_num = data.yhk_num
          this.fyk_num = data.fyk_num
          this.wz_num = data.wz_num
        }
      })
    },
    getTableDataJs () {
      var formData4 = new FormData() // 声明一个FormData对象

      agentService.getStatisticsOrderJsBt(formData4).then(data => {
        if (data != null && data != '') {
          this.js_amount = data.js_amount
          this.wjs_amount = data.wjs_amount
        }
      })
    },
    dateConversion (value) {
      if (value != null && value != '') {
        var d = new Date(value)
        //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        console.info('===========date=========' + date)
        return date
      } else {
        return ''
      }
    },
    getTableData () {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        start_time: this.dateConversion(this.dateRange[0]),
        end_time: this.dateConversion(this.dateRange[1]),
        agentid: util.cookies.get('agentid'),
        descending: this.sort.order === 'descending',
        filter: this.searchForm
      }
      agentService.getMobileOrderPagedlistSettlementBt(query).then(data => {
        this.tableData = data.rows
        this.page.total = data.totalCount
      })
    },
    handleSearchFormSubmit () {
      this.getTableData()
    },
    handleSearchFormReset () {
      this.getTableData()
    },
    handleExportFormSubmit () {
      window.location.href = encodeURI(process.env.VUE_APP_API + '/moblieapp/settlementtoExcelBt?agentid=' + util.cookies.get('agentid') + '&start_time=' + this.dateConversion(this.dateRange[0]) + '&end_time=' + this.dateConversion(this.dateRange[1]) + '&agent_name=' + this.searchForm.agent_name + '&js_state=' + this.searchForm.js_state)
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSortChange (val) {
      this.sort.prop = val.prop
      this.sort.order = val.order
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getTableData()
    },
    openEditForm (agent) {
      this.agent = agent
      this.pickerValue2 = this.dateConversion(this.dateRange[0])
      this.pickerValue3 = this.dateConversion(this.dateRange[1])
      this.editFormVisible = true
    },
    updateRelation (agent) {
      let msg = '补贴手续费'
      this.$confirm('确认' + msg + '操作？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: '取消'
      }).then(() => {
        agentService
          .updateRelation({ start_time: this.dateConversion(this.dateRange[0]), end_time: this.dateConversion(this.dateRange[1]), agentid: agent.zfb_num })
          .then(data2 => {
            if (data2 != 'true') {
              this.$message(data2)
            }
            this.getTableData()
          })
      })
    },
    batchDel () {
      let msg = '批量补贴'
      this.$confirm('确认' + msg + '操作？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: '取消'
      }).then(() => {
        agentService
          .updateRelationBatch({
            ids: JSON.stringify(this.multipleSelection.map(s => s.zfb_num)), start_time: this.dateConversion(this.dateRange[0]), end_time: this.dateConversion(this.dateRange[1])
          })
          .then(data2 => {
            if (data2 != 'true') {
              this.$message(data2)
            }
            this.getTableData()
          })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .header {
    font-size: 0.18rem;
    padding: 10px 0;
    border-bottom: 1px solid #ebeef5;
    &__line {
      width: 3px;
      background: rgb(16, 142, 233);
      height: 0.13rem;
      margin: 0 10px;
    }
  }
  .overview {
    width: 100%;
    border-radius: 10px;
    height: 1.3rem;
    min-height: 110px;
    &__col {
      font-size: 0.15rem;
      margin-top: 15px;
    }
    &__col:not(:last-child){
      border-right: 1px solid rgb(242, 242, 242);
    }
    &__title {
      color: rgb(137, 149, 160);
      margin-bottom: 10px;
    }
  }

</style>
